export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12065.a774ea0c.jpg";